export default {
  SET_DELIVERY_EMAIL_LOGS: function (state, payload) {
    state.deliveryEmailLogs = payload;
  }
}
